import React, { memo } from "react";
import _ from "lodash";
import PropTypes from 'prop-types';
import styles from "../Table.module.scss";

const SmallTable = (props) => {
  const { header, data, tableClass, obj, noscroll } = props;

  const getVal = (arr) => {
    let returnVal = <ol>
      {
        arr.map((item, index) => <li key={index} className={styles.homePageBulletsisk}>{item}</li>)
      }
    </ol>;
    return returnVal;
  };
  return (
    <>
      <div className={`table-responsive ${noscroll ? 'noscroll' : 'custom_scroll'} scroll-verticle ${tableClass}`}>
        <table width="100%" border={0} cellPadding={0} cellSpacing={0}>
          <tbody>
            <tr className={styles.thead}>
              {header.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
            {data ? (
              data.map((item, index) => (
                <tr key={index}>
                  {obj.map((obj, index) => {
                    return <td key={index}>{item[obj] ? (_.isArray(item[obj]) ? getVal(item[obj]) : item[obj]) : "-"}</td>;
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td>No Data Available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default memo(SmallTable);
SmallTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  obj: PropTypes.array.isRequired,
  tableClass: PropTypes.string.isRequired,
  noscroll: PropTypes.string.isRequired,
};


